import apiHandler from "../core/apiHandler";

const saleApi = apiHandler('sales');
export default saleApi;
